import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import MailIcon from '@material-ui/icons/Mail';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import Tutorial from '../complex/tutorial';

import { bindActionCreators } from 'redux';
import * as actions from '../../actions/process.home.actions';

import {
    XefIcon,
    AlertIcon,
    ProcessIcon,
    ReportIcon,
    ManageIcon,
    FastIcon,
    HomeIcon,
} from '../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';
import Popup from './Popup';

class Navigation extends React.Component {
    state = {
        open: false,
    };

    handleChange = (event, value) => {
        switch (value) {
            case 1:
                this.props.history.push('/processes');
                break;
            case 2: //FAST
                this.props.history.push('/ouichef');
                break;
            case 3: //INVENTARIO
                this.props.history.push('/xef');
                break;
            case 4: //REPORTES
                this.props.history.push('/reports');
                break;
            case 5: //ALERTAS
                this.props.history.push('/alerts');
                break;
            case 6: //GESTION
                this.props.history.push('/manage');
                break;
            case 7: //COMMUNICATIONS
                this.props.history.push('/communications');
                break;
            case 8: //MORE
                this.setState({ anchorEl: event.currentTarget });
                break;
            default:
                this.props.history.push('/');
        }
    };

    handleCloseMenu = (event) => {
        this.setState({ anchorEl: undefined });
    };

    render() {
        const { intl, active, hide, info, window_status, communications_pending, tutorial } = this.props;
        const { anchorEl } = this.state;

        const disabledProcess =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(
                info.security.totalPermits.some((f) => f === '57') &&
                info.security.licencias.some((f) => f.id === 150 && f.activo)
            );
        const disabledReport =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '57' || f === '60' || f === '86' ) &&
              info.security.licencias.some((f) => (f.id === 150 || f.id === 154 || f.id === 157) && f.activo));
        const disabledManage =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '62' || f === '64' || f === '80' || f === '84' || f === '110' || f === '111') &&
              info.security.licencias.some((f) => (f.id === 150 || f.id === 151 || f.id === 152 || f.id === 154 || f.id === 156 || f.id === 157) && f.activo));
        const disabledOuiXef =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '58') &&
              info.security.licencias.some((f) => f.id === 154 && f.activo));
        const disabledXhef =
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '67' || f === '66' || f === '68') &&
              info.security.licencias.some((f) => f.id === 154 && f.activo));
        const disabledBasic =
            info &&
            info.security &&
            info.security.totalPermits &&
            !info.security.licencias.some((f) => f.id === 150 && f.activo);
        const disabledCommunications =
            info &&
            info.security &&
            info.security.totalPermits &&
            !info.security.licencias.some((f) => f.id === 153 && f.activo);

      

        const pendingMails = (
            <div className="flex_auto_column center">
                {(communications_pending && ((communications_pending.communiaciones + communications_pending.mensajes) > 0)) &&
                    <div className="pendingMessages" />
                }
                <MailIcon className="mailrelative" />
            </div>
        );
        return (
            <div>
                {anchorEl && (
                    <Popup
                        {...this.props}
                        anchorEl={anchorEl}
                        handleChange={this.handleChange}
                        handleClose={this.handleCloseMenu.bind(this)}
                    />
                )}
                
                {tutorial && <Tutorial />}

                <BottomNavigation
                    value={active}
                    onChange={this.handleChange}
                    showLabels
                    className={classNames(
                        hide
                            ? 'navigationBar hide_app_bar'
                            : active === 2 && !window_status.appbar
                                ? 'always_app_bar'
                                : 'navigationBar',
                    )}
                >
                    <BottomNavigationAction
                        disabled={disabledBasic}
                        className={classNames('action', disabledBasic ? ' hide hideVertical' : '')}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'process_home' })}
                        icon={<HomeIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledProcess}
                        className={classNames('action', disabledProcess ? ' hide hideVertical' : '')}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'process_menu' })}
                        icon={<ProcessIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledOuiXef}
                        className={classNames(
                            'action hide',
                            disabledOuiXef ? ' hideVertical' : '',
                        )}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'fast_menu' })}
                        icon={<FastIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledXhef}
                        className={classNames(
                            'action hide',
                            disabledXhef ? ' hideVertical' : '',
                        )}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'inventory_menu' })}
                        icon={<XefIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledReport}
                        className={classNames('action', disabledReport ? ' hide hideVertical' : '')}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'report_menu' })}
                        icon={<ReportIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledProcess}
                        className={classNames(
                            'action hide',
                            disabledProcess ? ' hideVertical' : '',
                        )}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'warning_menu' })}
                        icon={<AlertIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledManage}
                        className={classNames(
                            'action hide',
                            disabledManage ? ' hideVertical' : '',
                        )}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'manage_menu' })}
                        icon={<ManageIcon />}
                    />
                    <BottomNavigationAction
                        disabled={disabledCommunications}
                        className={classNames('action', disabledCommunications ? ' hide hideVertical' : '')}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'manage_communications' })}
                        icon={pendingMails}
                    />
                    <BottomNavigationAction
                        className={classNames('action hideVertical')}
                        classes={{
                            selected: 'active',
                            label: 'label',
                        }}
                        label={intl.formatMessage({ id: 'more' })}
                        icon={<MoreVertIcon />}
                    />
                </BottomNavigation>
            </div>
        );
    }
}

Navigation.propTypes = {
    intl: intlShape.isRequired,
    history: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        info: state.info,
        window_status: state.window,
        communications_pending: state.communications_pending,
        tutorial: state.tutorial
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Navigation)));



// WEBPACK FOOTER //
// ./src/components/navbar/ResponsiveBottomNavigation.js